export default function (element) {
    const scrollHierarchy = [];
    let parent = element.parentNode;
    while (parent) {
        scrollHierarchy.push([parent, parent.scrollLeft, parent.scrollTop]);
        parent = parent.parentNode;
    }
    element.focus();
    scrollHierarchy.forEach((item) => {
        const element = item[0];
        if (element.scrollLeft !== item[1]) {
            element.scrollLeft = item[1];
        }
        if (element.scrollTop !== item[2]) {
            element.scrollTop = item[2];
        }
    });
}
//# sourceMappingURL=focus-without-scroll.js.map